import { FC, ReactNode } from "react";

interface Props {
  id: string;
  defaultChecked: boolean;
  onChange: (event: React.ChangeEvent<HTMLInputElement>) => void;
  label: ReactNode;
}

const ToggleField: FC<Props> = ({
  id,
  defaultChecked,
  onChange,
  label,
}): JSX.Element => {
  return (
    <label id={id} className="relative inline-flex items-center cursor-pointer">
      <input
        type="checkbox"
        value=""
        className="sr-only peer"
        checked={defaultChecked}
        onChange={onChange}
      />
      <div className="relative w-[44px] h-[24px] bg-gray-200 rounded-full peer peer-focus:ring-4 peer-focus:ring-blue-300 dark:peer-focus:ring-blue-800 dark:bg-gray-700 peer-checked:after:translate-x-full peer-checked:after:border-white after:content-[''] after:absolute after:top-[2px] after:left-[2px] after:bg-white after:rounded-full after:h-[20px] after:w-[20px] after:transition-all dark:border-gray-600 peer-checked:bg-valid flex-shrink-0"></div>
      <span className="ml-[8px] text-sm font-bold">{label}</span>
    </label>
  );
};

export default ToggleField;
